module.exports = __webpack_public_path__ + "img/Z86_11.3a191aa0.jpg";